import { SECTION_NAMES } from '@/config/widget';
import { derivedThemeValues } from '@/services/widgetTheme/derivedValues';
export const SECTION = derivedThemeValues(_ref => {
  var _theme$typography, _theme$typography$h, _theme$typography2, _theme$typography2$h, _theme$typography$big, _theme$typography$big2;

  let {
    theme,
    padding,
    remCalc,
    radius
  } = _ref;
  return {
    summary: {
      boxShadow: '0 4px 18px rgba(0, 0, 0, 0.12)'
    },
    [SECTION_NAMES.receipt]: {
      item: {
        color: theme.color.gray600,
        verticalPadding: padding(6),
        divider: {
          style: 'underline',
          color: theme.color.gray300
        }
      },
      divider: {
        color: theme.color.gray200
      }
    },
    [SECTION_NAMES.overview]: {
      columnGap: padding(6),
      rowGap: padding(6),
      item: {
        borderWidth: remCalc(1),
        borderColor: theme.color.border,
        borderRadius: remCalc(0),
        boxShadow: 'none',
        boxShadowSize: remCalc(0),
        paddingVertical: padding(3),
        paddingHorizontal: padding(3),
        paddingVerticalMdUp: padding(3),
        paddingHorizontalMdUp: padding(6),
        label: {
          fontFamily: theme.typography.fontFamily,
          fontWeight: theme.base.fontRegular,
          fontColor: theme.color.gray500,
          fontSize: theme.typography.fontSize,
          lineHeight: theme.typography.lineHeight
        },
        heading: {
          fontFamily: theme.typography.fontFamily,
          fontWeight: theme.base.fontSemibold,
          fontColor: theme.color.bodyFont,
          fontSize: (_theme$typography = theme.typography) === null || _theme$typography === void 0 ? void 0 : (_theme$typography$h = _theme$typography.h5) === null || _theme$typography$h === void 0 ? void 0 : _theme$typography$h.fontSize,
          lineHeight: (_theme$typography2 = theme.typography) === null || _theme$typography2 === void 0 ? void 0 : (_theme$typography2$h = _theme$typography2.h5) === null || _theme$typography2$h === void 0 ? void 0 : _theme$typography2$h.lineHeight
        },
        caption: {
          fontFamily: theme.typography.fontFamily,
          fontSize: (_theme$typography$big = theme.typography.big) === null || _theme$typography$big === void 0 ? void 0 : _theme$typography$big.fontSize,
          fontColor: theme.color.gray500,
          lineHeight: (_theme$typography$big2 = theme.typography.big) === null || _theme$typography$big2 === void 0 ? void 0 : _theme$typography$big2.lineHeight,
          fontWeight: theme.base.fontRegular
        }
      }
    },
    [SECTION_NAMES.table]: {
      borderColor: theme.color.borderMuted,
      borderRadius: radius(0),
      borderWidth: remCalc(0),
      horizontalBorderWidth: remCalc(0),
      header: {
        fontFamily: theme.typography.fontFamily,
        fontSize: theme.typography.fontSize,
        fontWeight: theme.base.fontRegular,
        fontColor: theme.color.gray500,
        lineHeight: theme.typography.lineHeight,
        backgroundColor: theme.color.bodyBackground
      },
      column: {
        paddingVertical: padding(3),
        paddingLeft: padding(0),
        paddingRight: padding(0),
        fontSize: theme.typography.fontSize,
        fontColor: theme.color.bodyFont
      }
    },
    [SECTION_NAMES.list]: {
      item: {
        verticalPadding: remCalc(12),
        horizontalPadding: remCalc(0),
        fontSize: theme.typography.fontSize,
        color: theme.color.gray500,
        text: {
          color: theme.color.bodyFont
        },
        label: {
          color: theme.color.bodyFont
        }
      },
      divider: {
        color: theme.color.gray200
      }
    }
  };
});